<template>
	<div class="content">
		<!-- 基本信息部分 -->
		<div class="user-box">
			<div class="img-box">
				<img class="headline" src="https://oss.pss.ink/outdoor/2022/12/30/20221230091236.png" alt="" srcset="">
			</div>
			<div class="info-box">
				<div>
					<div class="text1" @click="gotologin">领券账号</div>
					<div class="text2">{{this.mobile}}</div>
				</div>
			</div>
		</div>
		<!-- 优惠券部分列表 -->
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh">	
			<van-list v-model="loading" :finished="finished"  @load="onLoad" @offset="300" >
				<div class="card-list">
					<div class="card" v-for="(item,index) in list" :key="index">
						<div class="top-card">
							<div class="left">
								<div><span
										class="day">{{item.type ==1?item.deductionDays:item.deductionMoney}}</span>{{item.type ==1?'天':'元'}}
								</div>
							</div>
							<div class="middle">
								<div class="middle-text1">{{ item.name }}</div>
								<div class="middle-text2">{{ item.normsText }}</div>
								<div class="middle-text3">有效期：<span>{{item.useDayStart}}至{{item.useDayEnd}}</span></div>
							</div>
							<div class="right">
								<div v-if="item.receivedStatus ==1" class="use-btn right-btn" @click="goUse">去使用</div>
								<div v-if="item.receivedStatus == 0" class="revice-btn right-btn"
									@click="receiveCoupon(item)">领取</div>
							</div>
						</div>
						<div class="bottom-card">
							<div v-if="item.showExplain" @click="item.showExplain=!item.showExplain"> 使用说明
								<Icon class="arrow-down" name="arrow-down" />
							</div>
							<div v-else @click="item.showExplain=!item.showExplain"> 使用说明
								<Icon class="arrow-up" name="arrow-up" />
							</div>
							<div v-if="item.showExplain" class="coupon-des">{{ item.useExplain }}</div>
						</div>
						<div class="round round-left"></div>
						<div class="round round-right"></div>
					</div>    
				</div>
			</van-list>
			<van-empty description="暂无优惠券可领" v-if="list.length<1" />
		</van-pull-refresh>
		<!-- 按钮 -->
		<div class="btn-box" v-if="list.length>0"  >
			<div class="recive-bigbtn" :class="{disabled:isRecAll?true:false}" @click="recAll()">
				{{isRecAll?"全部已领":"全部领取"}}</div>
		</div>
	</div>
</template>

<script>
	import {
		storeCouponList,
		hasRecAllCoupon,
		receive
	} from '@/api/coupon.js';
	
	import { mapState, } from 'vuex';
	import {
		Icon,
		Toast,
		Empty 
	} from 'vant';
	export default {
		name: 'home',
		components: {
			Icon
		},
		data() {
			return {
				loading: false,
				finished: false,
				refreshing: false,
				isRecAll: false,
				list: [],
				totalPage: 0,
				para: {
					businessId: null,
					pageNum: 1,
					pageSize: 10
				}
			};
		},
		computed:{
			...mapState({
				mobile: state => state.user.mobile,
			})
		},
		created() {
			this.para.businessId = this.$route.query.businessId
			this.hasRecAllCoupon()
		},
		methods: {
			gotologin(){
				if(this.mobile==null||this.mobile=="")
				{
					this.$router.push({
						path: '/login',
						query: this.$route.query
					})
				}
			},
			getList() {
				storeCouponList(this.para).then(res => {
					if (res.records && res.records.length > 0) {
						this.totalPage = res.pages
						res.records.map((item, i) => {
							this.list.push({
								...item,
								showExplain: false
							})
						});
					}
					if (this.para.pageNum >= this.totalPage) this.finished = true
					this.loading = false
				});

			},
			onLoad() {
				if (!this.refreshing && this.para.pageNum < this.totalPage) {
					this.para.pageNum = this.para.pageNum + 1
				}
				if (this.refreshing) {
					this.list = [];
					this.refreshing = false;
				}
				this.getList();
			},
			hasRecAllCoupon() {
				hasRecAllCoupon({
					businessId: this.para.businessId
				}).then(res => {
					this.isRecAll = !res
				});

			},
			onRefresh() {
				// 清空列表数据
				this.refreshing = true
				this.finished = false
				this.loading = true
				this.para.pageNum = 1
				this.onLoad()
				this.hasRecAllCoupon()
			},
			receiveCoupon(item) {
				// console.log(item)
				if (item.receivedStatus == 1) {
					this.goUse()
				} else {
					receive({
						businessId: this.para.businessId,
						couponIds: [item.id]
					}).then(res => {
						item.receivedStatus = 1;
						Toast.success("领取成功")
					});
				}
			},
			goUse() {
				window.location.href = `https://ds.alipay.com/?scheme=` +
					encodeURIComponent(
						`alipays://platformapi/startapp?appId=2021002194605220&page=pages/index/index&query=${encodeURIComponent('')}`
						)
			},
			recAll() {
				if (this.isRecAll) {
					return
				}
				receive({
					businessId: this.para.businessId
				}).then(res => {
					if (this.list) {
						this.list.forEach(item => {
							item.receivedStatus = 1
						})
					}
					this.isRecAll = true;
					Toast.success("领取成功");
				});
			}
		}
	}
</script>

<style lang="css" scoped>
	@font-face {
		font-family: 'HeadLineA';
		src: url('https://qiniu.pisenpower.com/HeadlineA.ttf');
	}

	.content {
		height: 100vh;
		background: #F3F3F3;
		position: relative;
	}

	.user-box {
		display: flex;
		background-color: #fff;
	}

	.headline {
		width: 80px;
	}

	.info-box {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.text1 {
		font-size: 11px;
		color: #F35948;
	}

	.text2 {
		font-size: 18px;
		font-weight: bold;
	}

	.card-list {
		padding: 0 10px;
	}

	.card {
		padding: 10px;
		background-color: #fff;
		margin-top: 10px;
		box-shadow: 0px 6px 10px 0px rgba(88, 88, 88, 0.06);
		position: relative;
	}

	.round {
		background-color: #F3F3F3;
		width: 15px;
		height: 15px;
		border-radius: 50%;
		position: absolute;
		top: 76px;
	}

	.round-left {
		left: -8px;
	}

	.round-right {
		right: -8px;
	}

	.top-card {
		display: flex;
		border-bottom: 1px dashed #E4E4E4;
		;
		padding-bottom: 10px;
	}

	.left {
		font-size: 11px;
		display: flex;
		align-items: center;
	}

	.day {
		font-family: HeadLineA;
		font-size: 50px;
		margin-left: 10px;
	}

	.middle {
		flex: 1;
		margin-left: 30px;
	}

	.middle-text1 {
		font-weight: bold;
		font-size: 15px;
	}

	.middle-text2 {
		font-weight: bold;
		color: #3FBA0C;
		font-size: 12px;
		margin: 5px 0;
	}

	.middle-text3 {
		font-size: 11px;
		color: #444444;
	}

	.right {
		display: flex;
		align-items: center;
	}

	.right-btn {
		font-weight: bold;
		width: 60px;
		line-height: 22px;
		height: 22px;
		font-size: 13px;
		border-radius: 11px;
		text-align: center;
	}

	.use-btn {
		color: #FFFFFF;
		background: #000000;
	}

	.revice-btn {
		background: #BFFB73;
	}

	.bottom-card {
		padding: 10px 0 0 10px;
		color: #222222;
		font-size: 11px;
	}

	.btn-box {
		background-color: #fff;
		text-align: center;
		position: absolute;
		bottom: 0;
		width: 100%;
	}

	.recive-bigbtn {
		background: #000000;
		border-radius: 2px;
		font-size: 16px;
		color: #BEFF6C;
		padding: 8px 0;
		margin: 10px;
	}

	.coupon-des {
		padding: 10px 0;
	}
</style>
